/**
 * Display titles for inscribed media.
 *
 * Ordinals carry no title of their own: the wrapper answer a mint creates is a
 * system record with no content, so audio in particular used to surface as a
 * bare transport with nothing naming it. The ladder is the minting file's name,
 * then the origin inscription's txid. Surfaces that also have answer content
 * (the media dock) layer that on top as the first rung.
 */

/** Drop any stored path and the extension: `The Big Bad World.mp3` → `The Big Bad World`. */
export function mediaFileTitle(filename?: string | null): string | null {
    const name = String(filename || '')
        .split(/[\\/]/)
        .pop()
        ?.trim()
    if (!name) return null
    const stripped = name.replace(/\.[a-z0-9]{1,8}$/i, '').trim()
    return stripped || name
}

/**
 * `Ordinal #5d66e7ab` from an origin outpoint (`<txid>_<vout>`), a bare txid, or
 * — for surfaces holding only the Treechat record — a BsvOrdinal uuid.
 */
export function ordinalIdTitle(id?: string | null): string | null {
    const head = String(id || '')
        .trim()
        .split('_')[0]
        .replaceAll('-', '')
    if (!head) return null
    return `Ordinal #${head.slice(0, 8)}`
}

/**
 * Title for an ordinal's media: the file it was minted from, else its origin txid.
 * Returns null only when neither is known.
 */
export function ordinalMediaTitle({
    filename,
    origin,
    id,
}: {
    filename?: string | null
    origin?: string | null
    id?: string | null
}): string | null {
    return mediaFileTitle(filename) || ordinalIdTitle(origin) || ordinalIdTitle(id)
}
